import type { PlatformLayout } from "./types";

/** Level 1 — The Redwood Scrapyard. All slabs are 0.4 thick, 2 deep. */
export const REDWOOD_SCRAPYARD_PLATFORMS: PlatformLayout = {
  level: "RedwoodScrapyard",
  groundTopY: 0,
  platforms: [
    // Section 1: Entry (Puzzle 1)
    // p1_1 extended west to x=2 so the spawn area (cats at x=5, x=7)
    // lands on the same platform. Previously cats fell to ground with
    // no physics path back up — a level design gap.
    { name: "p1_1", w: 10, x: 7, y: 2 },
    { name: "p1_2", w: 3.5, x: 15, y: 3 },
    { name: "p1_3", w: 4, x: 20, y: 4 },
    { name: "p1_4", w: 3, x: 25, y: 5 },
    // Section 2: Mid (Puzzle 2)
    // p2_1, p4_1 and p5_1 (each section's first ledge) lowered 2.5 → 2.0 on
    // 2026-09-26. At top 2.7 they were above Basil's jump and 0.11u under
    // Minna's apex, so every section opened with a leap-or-precision climb
    // (layout-reachability lint). Top 2.2 matches p1_1.
    { name: "p2_1", w: 4, x: 37, y: 2 },
    { name: "p2_2", w: 3.5, x: 42, y: 4 },
    { name: "p2_3", w: 4, x: 47, y: 3 },
    { name: "p2_4", w: 3, x: 52, y: 5 },
    { name: "p2_5", w: 3.5, x: 57, y: 6 },
    // No ledge near the crow's nest (x≈66.8, 7u up): the open ground between
    // p2_5 and p3_1 keeps it out of every ordinary jump, so only Basil's
    // Overclocked Leap lifts food there (CrowSquirrel.ts). The old p2_6
    // perch over x=45 went with the old nest.
    // Section 3: Kitten area (Puzzle 3)
    { name: "p3_1", w: 4, x: 75, y: 2 },
    { name: "p3_2", w: 3.5, x: 80, y: 3.5 },
    { name: "p3_3", w: 4, x: 85, y: 2.5 },
    { name: "p3_4", w: 3, x: 90, y: 4 },
    { name: "p3_5", w: 5, x: 95, y: 3 },
    { name: "p3_6", w: 3.5, x: 100, y: 5.5, route: "minna", note: "2.5u rise: Minna jumps (0.31u slack), Basil leaps" },
    // Section 4: Apex (Puzzle 4)
    { name: "p4_1", w: 4, x: 112, y: 2 },
    { name: "p4_2", w: 3.5, x: 118, y: 4 },
    { name: "p4_3", w: 4, x: 124, y: 3 },
    { name: "p4_4", w: 3, x: 130, y: 5 },
    // Section 5: Final (Puzzle 5 + Elder)
    { name: "p5_1", w: 4, x: 138, y: 2 },
    { name: "p5_2", w: 5, x: 145, y: 4 },
    { name: "p5_3", w: 3, x: 150, y: 3 },
  ],
};
